export interface CookieAttributes {
  domain: string;
  path: string;
  secure: boolean;
  sameSite: 'strict' | 'Strict' | 'lax' | 'Lax' | 'none' | 'None';
}

export const getDefaultSharedCookieOptions = (): CookieAttributes => {
  // This will be served from .avalara.com or .avalara.io or localhost
  const domainMatch = window.location.host.match(/\.avalara\.com/) || window.location.host.match(/\.avalara\.io/) || ['/'];
  const isUnrecognizedDomain = domainMatch[0] === '/';

  return {
    sameSite: 'lax',
    domain: isUnrecognizedDomain ? '' : domainMatch[0],
    path: '/',
    secure: !isUnrecognizedDomain,
  } as CookieAttributes;
};
